module.exports = __webpack_public_path__ + "assets/images/7976dae32f724d497fd994cbdfcb6c83.svg";